import { Component } from "solid-js";

export const NotFound: Component<{}> = (props) => {
  return <h1>404 - Not Found</h1>;
};
